// const baseUrl = `http://localhost:6600`; // FE + BE Development
// const baseUrl = 'https://chat.srhr.org'; // FE Development
const baseUrl = `${window.location.protocol}//${window.location.host}`; // Production

export const indicatorEndpoint = `${baseUrl}/indicator`;
